import React from 'react';
import { settings } from '../constants';
import FsBeacon from "../../../assets/components/fs-beacon/FsBeacon";

class FsgoItem extends React.Component {
	constructor(props) {
		super(props);
	}

    handleClick() {
        let props = {
            postType: this.props.postType,
            content: this.props.state
        };
        FsBeacon.EpgTracking(props).send();
    }

	render() {
		const state = this.props.state;
		const idx = this.props.idx;
		const isLive = state === 'live';
		const v = this.props.item;
		const isMobileStreamingAllowed = v.tag !== settings.NOT_ALLOWED_MOBILE_STREAMING_TAG;
		const imageClassName = `video-img ${this.props.isPost ? 'at-post' : ''}`;
		const videoDescClassName = `video-desc ${this.props.isPost ? 'at-post' : ''}`;


		return (
			<li className={`video-list ${state}`} onClick={() => this.handleClick()}>

				<a href={v.url}
				   id={`tune-in-video-${state}-${idx}`}
				   target="_blank"
				   className={`video-link ${!isMobileStreamingAllowed ? 'disable-link' : ''}`}>
					<figure className="video-thumbnail">
						<div className="img-wrap">
							<img className={imageClassName + (v.resizedImageUrlSmall ? ' hide-on-small' : '') + ' lazyload'}
								 alt={v.title}
								 data-src={v.resizedImageUrl}
								 data-srcset={v.resizedImageUrl}/>
							{v.resizedImageUrlSmall &&
								<img className={imageClassName + ' hide-on-large lazyload'}
									 alt={v.title}
									 data-src={v.resizedImageUrlSmall}
									 data-srcset={v.resizedImageUrlSmall}/>
							}
						</div>
						<div className={`channel-container ${(v.channelDescription || '').toLowerCase()}`}>
							{isLive && v.tag && <div className="channel-desc">{v.tag}</div>}
							<div className="channel-desc">{v.channelDescription}</div>
						</div>
						{isLive && <div className="gradient-overlay"></div>}
					</figure>
					<div className={videoDescClassName}>
						{/*isLive &&
							<div className="key-icon-container">
								<span className="key-icon"></span>
							</div>*/
						}
						{isLive
							?
							<div className="live-time-wrapper">
								<span className="state"></span>
							</div>
							:
							<span className="state">
								{v.formattedStartTime + ' '}
								{/*<span className="key-icon"></span>*/}
							</span>
						}

						<span className="desc">{v.title}</span>
						{v.isReplay &&
							<span className="replay"> REPLAY </span>
						}
					</div>
					{!isMobileStreamingAllowed &&
						<div className="availability-alert">
							<div className="alert-title">Available on</div>
							<div className="alert-devices">Tablet, Computer & Connected Devices</div>
						</div>
					}
				</a>
			</li>
		)
	}
}

export default FsgoItem;



// WEBPACK FOOTER //
// ./react-app-src/fsgo/components/FsgoItem.js